import { createDomain, type Scope, fork, sample } from 'effector';
import { signout } from '@features/common';
import { getResidentOwnershipStatus } from './api';
import type { GetResidentOwnershipStatusResponse, GetList, Status } from './types';

export const ControlDomain = createDomain();

const scopes: { [key: string]: Scope } = {};

export const createScope = (name: string) => {
  if (scopes[name]) {
    return scopes[name];
  }

  scopes[name] = fork(ControlDomain);

  return scopes[name];
};

export const getList = ControlDomain.createEvent<GetList>();

export const $data = ControlDomain.createStore<Status[]>([]);
export const $pending = ControlDomain.createStore<boolean>(false);

export const fxGetResidentOwnershipStatus = ControlDomain.createEffect<
  void,
  GetResidentOwnershipStatusResponse,
  Error
>().use(getResidentOwnershipStatus);

/** Запрос данных */
sample({
  clock: getList,
  fn: (residentType) =>
    residentType
      ? {
          resident_type: residentType,
        }
      : undefined,
  target: fxGetResidentOwnershipStatus,
});

$pending.on(fxGetResidentOwnershipStatus.pending, (_, pending) => pending).reset(signout);

$data
  .on(fxGetResidentOwnershipStatus.doneData, (_, { available_filters }) =>
    Array.isArray(available_filters)
      ? available_filters.map((item) => ({
          id: item?.type,
          label: item?.title ?? '',
        }))
      : []
  )
  .reset(signout);
